import React, { useEffect, useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useNavigate, useParams } from "react-router-dom";
import {
  cmsgallerylist,
  cmsresourcelist,
  leaderlist,
  medalsdetaillist,
  medalslist,
  photoslist,
  playsessionview,
  schooldetails,
  schoolstatementview,
  storylist,
  storyview,
  toureventlist,
} from "../services/site";
import moment from "moment";
import { Col, Modal, Row } from "react-bootstrap";
import dotracking from "./trackinglogs";
import { AgGridReact } from "ag-grid-react";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
export const Website = () => {
  const { sch, id } = useParams();
  const [schname, setSchName] = useState("");
  const [schcode, setSchCode] = useState("");
  const [schlogo, setSchLogo] = useState("");
  const navigate = useNavigate();

  const [shead, setSHead] = useState("");
  const [desc, setDesc] = useState("");
  const [simage, setImage] = useState("");

  const [sface, setSFace] = useState("");
  const [sinsta, setSInsta] = useState("");
  const [syoutube, setSYoutube] = useState("");

  const [tourlist, setTourList] = useState([]);

  const [platses, setPlaySes] = useState("");
  const [mcount, setMCount] = useState("");
  const [tcount, setTCount] = useState("");
  const [scount, setSCount] = useState("");

  const [stlist, setStList] = useState([]);
  const [stpath, setStPath] = useState("");

  const [gllist, setGList] = useState([]);
  const [gtpath, setGtPath] = useState("");

  const [reslist, setResList] = useState([]);
  const [respath, setResPath] = useState("");

  const [lboard, setLBoard] = useState([]);
  const [stype, setStype] = useState("");

  const [medlist, setMedList] = useState([]);
  const [mlshow, setMLShow] = useState(false);
  const columnDefs = [
    {
      headerName: "Tournament",
      field: "meet_name",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "Name",
      field: "first_name",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Gender",
      field: "gender",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Level",
      field: "level",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Position",
      field: "position",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Sports",
      field: "sports_type",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Event",
      field: "event",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Category",
      field: "category_name",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
  ];
  useEffect(() => {
    const url = window.location.href.split("/#/");
    const head = url[1].split("/");
    if (head[1] == 123) {
      const script = document.createElement("script");
      script.src = "https://www.googletagmanager.com/gtag/js?id=G-D7M14T62RR";
      script.async = true;

      // Append the script to the document head
      document.head.appendChild(script);

      // Create and configure the inline script for gtag
      const inlineScript = document.createElement("script");
      inlineScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-D7M14T62RR');
      `;

      // Append the inline script to the document head
      document.head.appendChild(inlineScript);

      // Cleanup function to remove the scripts when the component unmounts
      // return () => {
      //   document.head.removeChild(script);
      //   document.head.removeChild(inlineScript);
      // };
    }

    schooldetails(id).then((res1) => {
      if (res1.status === true && res1.data.details !== null) {
        var sl = res1.data.details.school_name.toLowerCase();
        sl = sl.trim();
        sl = sl.replace(/ /g, "_");
        window.location.replace('https://pathwayz.sportzvillage.com/school/#/'+sl+"/" + id);
        setSchCode(res1.data.details.id);
        setSchName(res1.data.details.school_name);
        if (res1.data.details.school_logo !== null) {
          setSchLogo(res1.data.s3_logo + res1.data.details.school_logo);
        }
        schoolstatementview(res1.data.details.id).then((response) => {
          if (response.status === true) {
            if (response.data.school_statement !== null) {
              setSHead(response.data.school_statement.heading);
              setDesc(response.data.school_statement.description);
              if (response.data.school_statement.fb_url !== null) {
                setSFace(response.data.school_statement.fb_url);
              }
              if (response.data.school_statement.insta_url !== null) {
                setSInsta(response.data.school_statement.insta_url);
              }
              if (response.data.school_statement.youtube_url !== null) {
                setSYoutube(response.data.school_statement.youtube_url);
              }

              if (response.data.school_statement.image_path !== null) {
                setImage(
                  response.data.logo_path +
                    response.data.school_statement.image_path
                );
              }
            }
          }
        });
        let arr = [];
        toureventlist(res1.data.details.id).then((response) => {
          if (response.status === true) {
            if (response.data.tournament_list.length > 0) {
              for (let i = 0; i < response.data.tournament_list.length; i++) {
                var chk = "";
                if (
                  moment(new Date()).format("YYYY-MM-DD") >
                  moment(
                    response.data.tournament_list[i].entry_deadline_date
                  ).format("YYYY-MM-DD")
                ) {
                  chk = "Closed";
                }
                arr.push({
                  id: response.data.tournament_list[i].id,
                  start_date: response.data.tournament_list[i].start_date,
                  meet_name: response.data.tournament_list[i].meet_name,
                  type: "Tournament",
                  exttype: "Internal",
                  entry_open: response.data.tournament_list[i].entry_open,
                  entry_deadline_date:
                    response.data.tournament_list[i].entry_deadline_date,
                  status: chk,
                  meet_url: response.data.tournament_list[i].meet_url,
                  tournament_logo:
                    response.data.tournament_list[i].tournament_logo,
                  tournament_logo_path: response.data.tournament_logo_path,
                });
              }
            }

            if (response.data.all_ext_tournament_list.length > 0) {
              for (
                let i = 0;
                i < response.data.all_ext_tournament_list.length;
                i++
              ) {
                var chk = "";
                if (
                  moment(new Date()).format("YYYY-MM-DD") >
                  moment(
                    response.data.all_ext_tournament_list[i].entry_deadline_date
                  ).format("YYYY-MM-DD")
                ) {
                  chk = "Closed";
                }
                arr.push({
                  id: response.data.all_ext_tournament_list[i].id,
                  start_date:
                    response.data.all_ext_tournament_list[i].start_date,
                  meet_name: response.data.all_ext_tournament_list[i].meet_name,
                  type: "Tournament",
                  exttype: "External",
                  entry_open: "",
                  entry_deadline_date: "",
                  school_id: response.data.all_ext_tournament_list[i].school_id,
                  status: "",
                  meet_url: "",
                  tournament_logo: "",
                });
              }
            }

            if (response.data.event_list.length > 0) {
              for (let i = 0; i < response.data.event_list.length; i++) {
                var chk = "";
                if (
                  moment(new Date()).format("YYYY-MM-DD") >
                  moment(response.data.event_list[i].entry_end_date).format(
                    "YYYY-MM-DD"
                  )
                ) {
                  chk = "Closed";
                }
                arr.push({
                  id: response.data.event_list[i].id,
                  start_date: response.data.event_list[i].start_date,
                  meet_name: response.data.event_list[i].event_name,
                  type: "Event",
                  exttype: "Event",
                  entry_open: response.data.event_list[i].entry_start_date,
                  entry_deadline_date:
                    response.data.event_list[i].entry_end_date,
                  status: chk,
                  meet_url: response.data.event_list[i].meet_url,
                  tournament_logo: "",
                  tournament_logo_path: response.data.tournament_logo_path,
                });
              }
            }
            setTourList(arr);
            setTCount(
              parseInt(response.data.all_tournament_list.length) +
                parseInt(response.data.all_ext_tournament_list.length) +
                parseInt(response.data.all_achievement_tournament_list.length)
            );
          }
        });
        if (id == 0) {
          leaderlist(221).then((response) => {
            if (response.status === true) {
              setLBoard(response.data.leaderboard_list);
            }
          });
        } else if (id == 123) {
          leaderlist(236).then((response) => {
            if (response.status === true) {
              setLBoard(response.data.leaderboard_list);
            }
          });
        }

        medalsdetaillist(res1.data.details.id, 1).then((response) => {
          if (response.status === true) {
            let arr = [];
            let arr1 = [];
            if (response.data.other_achivements.length !== 0) {
              arr1 = response.data.other_achivements;
            }
            if (response.data.football_achievements.length !== 0) {
              arr = response.data.football_achievements;
            }
            let arr2 = arr1.concat(arr);
            setMedList(arr2);
          }
        });
        const temp = new FormData();
        temp.append("year", 0);
        temp.append("sports", 0);
        temp.append("school_id", res1.data.details.id);

        medalslist(temp).then((res) => {
          if (res.status === true) {
            let mcnt = 0;
            let tcnt = 0;
            let scnt = 0;
            for (let i = 0; i < res.data.length; i++) {
              // if (typeof res.data[i].meet_count === "string") {
              //   tcnt += parseInt(res.data[i].meet_count);
              // } else {
              //   tcnt += res.data[i].meet_count;
              // }

              if (typeof res.data[i].participants === "string") {
                scnt += parseInt(res.data[i].participants);
              } else {
                scnt += res.data[i].participants;
              }

              if (typeof res.data[i].total_achievements === "string") {
                mcnt += parseInt(res.data[i].total_achievements);
              } else {
                mcnt += res.data[i].total_achievements;
              }
            }
            setMCount(mcnt);
            // setTCount(tcnt);
            setSCount(scnt);
          }
        });

        playsessionview(res1.data.details.id).then((res) => {
          if (res.status === true) {
            if (res.data.play_sessions !== null) {
              setPlaySes(res.data.play_sessions.play_sessions);
            }
          }
        });

        storylist(res1.data.details.id).then((res) => {
          if (res.status === true) {
            setStPath(res.data.logo_path);
            setStList(res.data.success_stories_list);
          }
        });

        cmsgallerylist(res1.data.details.id).then((response) => {
          if (response.status === true) {
            setGtPath(response.data.img_path);
            setGList(response.data.gallery_list);
          }
        });
        cmsresourcelist(res1.data.details.id, "", 1).then((res) => {
          if (res.status === true) {
            setResPath(res.data.logo_path);
            setResList(res.data.resources_list);
          }
        });

        dotracking(1, id, "Home", 0, res1.data.details.id);
      }
    });
  }, []);
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2,
      slidesToSlide: 1, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };

  const tourresponsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1014 },
      items: 4,
      slidesToSlide: 1, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1014, min: 464 },
      items: 2,
      slidesToSlide: 1, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
      slidesToSlide: 1, // optional, default to 1.
    },
  };

  function errorhandle(ev) {
    ev.target.src = require("../assets/images/logo-pathway.png");
    ev.target.onerror = null;
  }

  function errorimghandle(ev) {
    ev.target.src = require("../assets/images/users.png");
    ev.target.onerror = null;
  }

  function errortour(ev) {
    ev.target.src = require("../assets/images/logo_epl.png");
    ev.target.onerror = null;
  }
  const [sshow, setSShow] = useState(false);
  const [stitle, setSTitle] = useState("");
  const [sdesc, setSDesc] = useState("");
  const [sphto, setSImage] = useState("");
  const [sdesc1, setSDesc1] = useState("");
  function handlestory(sid) {
    storyview(sid).then((response) => {
      if (response.status === true) {
        setSShow(true);
        setSTitle(response.data.success_stories_details.article_title);
        setSDesc(response.data.success_stories_details.article_description);
        if (response.data.success_stories_details.article_image !== null) {
          setSImage(
            response.data.logo_path +
              response.data.success_stories_details.article_image
          );
        }

        setSDesc1(response.data.success_stories_details.article_content);
      }
    });
  }

  function handlestoryclose() {
    setSShow(false);
    setSTitle("");
    setSDesc("");
    setSDesc1("");
    setSImage("");
  }

  const [ishow, setIShow] = useState(false);
  const [pimage, setPImage] = useState(false);
  const [pimgtype, setPImgType] = useState("");
  const [pimgurl, setPImgUrl] = useState("");

  function handlepop(img, itype, ifile) {
    if (itype === "Video") {
      if (ifile === "url") {
        let newstr1 = img.substr(img.length - 11);
        let curvideo = "";
        let res = img.substring(0, 23);
        curvideo = "https://www.youtube.com";
        if (curvideo == res) {
          setPImage(`https://www.youtube.com/embed/${newstr1}`);
        }
      } else {
        setPImage(respath + img);
      }
    } else {
      setPImage(respath + img);
      // setPImage(img+"#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true");
    }
    setPImgUrl(ifile);
    setIShow(true);
    setPImgType(itype);
  }

  function imageclose() {
    setIShow(false);
    setPImage("");
  }

  const [shareUrl, setShare] = useState("");
  const [show, setShow] = useState(false);

  function handleshow(timg) {
    setShare(timg);
    setShow(true);
    dotracking(1, id, "Share", 0, timg);
  }
  const handleclose = () => {
    setShow(false);
  };

  function handlelike(lid) {
    const gdata = gphoto.findIndex((item) => item.id == lid);
    if (gdata !== -1) {
      const updatedGphoto = gphoto.map((item, index) => 
        index === gdata ? { ...item, like: !item.like } : item
      );
      setGallery(updatedGphoto);
    }
  }

  const [gcpshow, setGCPShow] = useState(false);
  const [gphoto, setGallery] = useState([]);
  function handlegcpopen(cid) {
    setGCPShow(true);
    photoslist(cid).then((response) => {
      if (response.status === true) {
        if (response.data.tournamentlist.length !== 0) {
          let arr1 = [];
          for (let i = 0; i < response.data.tournamentlist.length; i++) {
            arr1.push({
              id: response.data.tournamentlist[i].id,
              src:
                response.data.tournamentimage_path +
                response.data.tournamentlist[i].imagename,
              like: false,
            });
          }
          setGallery(arr1);
        }
      }
    });
  }
  function handlegcpclose() {
    setGCPShow(false);
    setGallery([]);
  }

  function tourdet(tid, ttype) {
    dotracking(1, id, "Tournament", tid, schcode);
    if (ttype == "External") {
      navigate(`/externaltournamentdetails/${id}/${tid}/${schcode}`);
    } else {
      navigate(`/tournamentdetails/${id}/${tid}/${schcode}`);
    }
  }

  function eventdet(tid) {
    dotracking(2, id, "Event", tid, schcode);
    navigate(`/eventdetails/${id}/${tid}/${schcode}`);
  }
  return (
    <div className="custom-cursor">
      <div className="page-wrapper">
        <header className="main-header main-header--two sticky-header sticky-header--two sticky-header--normal">
          <div className="container-fluid">
            <div className="main-header__inner">
              <div className="main-header__logo logo-retina">
                <a>
                  <img
                    src={schlogo}
                    onError={(e) => errorhandle(e)}
                    className="main-header__logo__light"
                  />
                </a>
              </div>
              <div className="main-header__center-wrap">
                <h3 className="mb-0">{schname}</h3>
              </div>
              <div className="main-header__right-wrap">
                <div className="main-header__right">
                  <a>
                    <img
                      src={require("../assets/images/logo_sv.png")}
                      alt=""
                      width="150"
                      className="main-header__logo__light"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </header>

        {/* <header className="main-header main-header--two sticky-header sticky-header--two sticky-header--normal sticky-header--cloned active">
                <div className="container-fluid">
                    <div className="main-header__inner">
                        <div className="main-header__logo logo-retina">
                            <a >
                                <img src={require("../assets/images/logo_school2.png")} alt="" width="" className="main-header__logo__light" />
                            </a>
                        </div>
                        <div className="main-header__center-wrap">
                            <h3 className="mb-0">Pushpalata Vidya Mandir</h3>
                        </div>
                        <div className="main-header__right-wrap">
                            <div className="main-header__right">
                                <a >
                                    <img src={require("../assets/images/logo_sv.png")} alt="" width="150" className="main-header__logo__light" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </header> */}

        <section className="main-slider-two" id="home">
          <div className="main-slider-two__inner">
            <div
              className="main-slider-two__inner__bg"
              style={{
                backgroundImage: `url(${require("../assets/images/shapes/main-slider-shape-bg-2-2.png")})`,
              }}
            ></div>
          </div>
          <div className="main-slider-two__carousel easilon-owl__carousel owl-carousel">
            <div className="owl-item active">
              {/* style={{ width: "1349px" }} */}
              <div className="item">
                <div className="main-slider-two__item">
                  <div
                    className="main-slider-two__bg"
                    style={{
                      backgroundImage: `url(${require("../assets/images/shapes/main-slider-shape-bg-2-1.png")})`,
                    }}
                  ></div>
                  <div className="main-slider-two__social social-links-two">
                    <a href={sface} target="_blank">
                      <span className="social-links-two__icon">
                        <i className="fab fa-facebook-f" aria-hidden="true"></i>
                      </span>
                      <span className="sr-only">Facebook</span>
                    </a>
                    <a href={sinsta} target="_blank">
                      <span className="social-links-two__icon">
                        <i className="fab fa-instagram" aria-hidden="true"></i>
                      </span>
                      <span className="sr-only">Instagram</span>
                    </a>
                    <a href={syoutube} target="_blank">
                      <span className="social-links-two__icon">
                        <i className="fab fa-youtube" aria-hidden="true"></i>
                      </span>
                      <span className="sr-only">Youtube</span>
                    </a>
                  </div>
                  <div className="main-slider-two__container container">
                    <div className="row gutter-y-60 align-items-center">
                      <div className="col-xxl-6 col-xl-9">
                        <div className="main-slider-two__content">
                          <div className="main-slider-two__top"></div>
                          <h2 className="main-slider-two__title">{shead}</h2>
                          <div className="main-slider-two__text-box">
                            <p className="main-slider-two__text">{desc}</p>
                          </div>
                          <div className="main-slider-two__content__shape-box">
                            <div className="main-slider-two__content__shape-circle"></div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-6 col-xl-3">
                        {simage !== "" && (
                          <div className="main-slider-two__image">
                            <div className="main-slider-two__image__inner">
                              <img src={simage} alt="slider image" />
                            </div>
                            <div className="main-slider-two__image__shape-box">
                              <img
                                src={require("../assets/images/shapes/main-slider-shape-2-2.png")}
                                alt="shape"
                                className="main-slider-two__image__shape-two"
                              />
                              <img
                                src={require("../assets/images/shapes/main-slider-shape-2-3.png")}
                                alt="shape"
                                className="main-slider-two__image__shape-three"
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="company-info-one py-5 d-none">
          <div className="container">
            <div className="company-info-one__inner">
              {/* <div className="company-info-one__inner__bg" style="background-image: url(assets/images/backgrounds/company-info-bg-1-1.jpg);"></div> */}
              <div className="row gutter-y-50">
                <div
                  className="col-lg-12 col-sm-12 text-center wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="00ms"
                >
                  <div className="company-info-one__item">
                    <h4 className="company-info-one__item__title">
                      School Statement / Mission Statement
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {(id == 0 || id == 123) && (
          <section className="work-process-one section-space position-relative">
            <div
              className="why-choose-one__bg"
              // style={{
              //   backgroundImage: `url(${require("../assets/images/shapes/why-choose-bg-1-1.png")})`,
              // }}
            ></div>
            <div className="container">
              <div className="sec-title sec-title--center">
                <h3 className="sec-title__title">Overall Leaderboard</h3>
                <div className="sec-title__top">
                  <div className="sec-title__shape">
                    <div className="sec-title__shape__one"></div>
                    <div className="sec-title__shape__two"></div>
                  </div>
                  <div className="sec-title__shape">
                    <div className="sec-title__shape__one"></div>
                    <div className="sec-title__shape__two"></div>
                  </div>
                </div>
              </div>
              <div className="row gutter-y-30">
                {/* <div id="no-more-tables"> */}
                <div className="col-md-12 table-responsive">
                  {/* table-condensed cf */}
                  <table
                    className="table table-bordered table-striped "
                    cellPadding="10px"
                  >
                    {/*  */}
                    <thead style={{ textAlign: "center" }} className="cf">
                      <tr>
                        <th>Team</th>
                        <th>Cricket</th>
                        <th>Athletics</th>
                        <th>Badminton</th>
                        <th>Football</th>
                        <th>Table Tennis</th>
                        <th>Basketball</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <thead style={{ textAlign: "center" }} className="rescf">
                      <tr>
                        <th>Team</th>
                        <th>
                          <div>
                            <img
                              src={require("../assets/images/sports/CRICKET.png")}
                            />
                          </div>
                        </th>
                        <th>
                          <img
                            src={require("../assets/images/sports/ATHLETICS.jpg")}
                          />
                        </th>
                        <th>
                          <img
                            src={require("../assets/images/sports/BATMINTON.png")}
                          />
                        </th>
                        <th>
                          <img
                            src={require("../assets/images/sports/FOOTBALL.png")}
                          />
                        </th>
                        <th>
                          <img
                            src={require("../assets/images/sports/TENNIS.png")}
                          />
                        </th>
                        <th>
                          <img
                            src={require("../assets/images/sports/BASKETBALL.png")}
                          />
                        </th>
                        <th>Total</th>
                      </tr>
                    </thead>

                    <tbody>
                      {lboard.length == 0 && (
                        <tr>
                          <td
                            colSpan="8"
                            style={{ textAlign: "center" }}
                            className="text-danger"
                          >
                            Leaderboard will be updated soon
                          </td>
                        </tr>
                      )}

                      {lboard.map((item, index) => {
                        return (
                          <tr key={index} style={{ textAlign: "center" }}>
                            <td data-title="Team">{item.team_house_name}</td>
                            <td data-title="Cricket">{item.cricket}</td>
                            <td data-title="Athletics">{item.athletics}</td>
                            <td data-title="Badminton">{item.badminton}</td>
                            <td data-title="Football">{item.football}</td>
                            <td data-title="TableTennis">{item.table_tennis}</td>
                            <td data-title="Basketball">{item.basket_ball}</td>

                            <td data-title="Total">{item.total}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        )}

        {tourlist.length > 0 && (
          <section className="blog-two section-space" id="blog">
            <div className="container">
              <div className="sec-title sec-title--center">
                <h3 className="sec-title__title">Tournament and Events</h3>
                <div className="sec-title__top">
                  <div className="sec-title__shape">
                    <div className="sec-title__shape__one"></div>
                    <div className="sec-title__shape__two"></div>
                  </div>
                  <div className="sec-title__shape">
                    <div className="sec-title__shape__one"></div>
                    <div className="sec-title__shape__two"></div>
                  </div>
                </div>
              </div>
              <div className="row gutter-y-30">
                <Carousel
                  swipeable={true}
                  draggable={true}
                  showDots={true}
                  responsive={tourresponsive}
                  ssr={true} // means to render carousel on server-side.
                  infinite={true}
                  autoPlay={true}
                  autoPlaySpeed={5000}
                  keyBoardControl={true}
                  customTransition="all .5"
                  transitionDuration={500}
                  containerClass="carousel-container"
                  removeArrowOnDeviceType={["tablet", "mobile"]}
                  // deviceType={this.props.deviceType}
                  dotListClass="custom-dot-list-style"
                  itemClass="carousel-item-padding-40-px"
                >
                  {tourlist.map((item, index) => {
                    return (
                      <div
                        style={{ height: "420px" }}
                        key={index}
                        className="mt-2"
                      >
                        <div
                          className="blog-card blog-card--two wow fadeInUp me-2"
                          data-wow-duration="1500ms"
                          data-wow-delay="00ms"
                          title={item.meet_name}
                        >
                          <div className="blog-card__content text-center">
                            <div className="blog-card__date">
                              <span className="blog-card__date__day">
                                {moment(item.start_date).format("YYYY")}
                              </span>
                              <span className="blog-card__date__month">
                                {moment(item.start_date).format("DD, MMMM")}
                              </span>
                            </div>
                            <div className="blog-card__image">
                              {item.type == "Tournament" &&
                                item.tournament_logo !== "" && (
                                  <img
                                    height="150px"
                                    src={
                                      item.tournament_logo_path +
                                      item.tournament_logo
                                    }
                                    onError={(e) => errortour(e)}
                                  />
                                )}
                              {item.type == "Tournament" &&
                                item.tournament_logo == "" && (
                                  <img
                                    height="150px"
                                    src={require("../assets/images/logo_epl.png")}
                                  />
                                )}
                              {item.type == "Event" && (
                                <img
                                  height="150px"
                                  src={require("../assets/images/logo-pathway.png")}
                                  alt="#"
                                />
                              )}
                            </div>
                            <h3
                              className="blog-card__title"
                              title={item.meet_name}
                            >
                              <a>{item.meet_name}</a>
                            </h3>
                          </div>
                          {/* {item.type == "Tournament" && item.status == "" && (
                            <div className="blog-card__content_bottom text-center">
                              <a
                                className="btn btn-primary"
                                onClick={() => tourdet(item.id)}
                              >
                                Register now
                              </a>
                            </div>
                          )} item.status !== "" && */}
                          {item.type == "Tournament" && (
                            <div className="blog-card__content_bottom text-center">
                              <a
                                className="btn btn-danger"
                                onClick={() => tourdet(item.id, item.exttype)}
                              >
                                See Tournament
                              </a>
                            </div>
                          )}

                          {item.type == "Event" && (
                            <div className="blog-card__content_bottom text-center">
                              <a
                                className="btn btn-danger"
                                onClick={() => eventdet(item.id)}
                              >
                                See Event
                              </a>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </Carousel>
              </div>
            </div>
            <img
              src={require("../assets/images/shapes/about-shape-2-1.png")}
              alt="shape"
              className="about-two__shape"
            />
          </section>
        )}

        <section className="funfact-one">
          <div
            className="funfact-one__bg"
            style={{
              backgroundImage: `url(${require("../assets/images/shapes/funfact-bg-1-1.jpg")})`,
            }}
          ></div>

          <div className="container">
            <div className="row gutter-y-40">
              <div
                className="funfact-one__col col-lg-3 col-sm-6 wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="00ms"
              >
                <div className="funfact-one__item">
                  <h3 className="funfact-one__item__number count-box">
                    <span className="count-text"></span>
                    <span>{platses}hrs</span>
                  </h3>
                  <h4 className="funfact-one__item__title">
                    Sports Represented
                  </h4>
                </div>
              </div>
              <div
                className="funfact-one__col col-lg-3 col-sm-6 wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="100ms"
              >
                <div className="funfact-one__item">
                  <h3 className="funfact-one__item__number count-box">
                    <span className="count-text">{scount}</span>
                  </h3>
                  <h4 className="funfact-one__item__title">
                    Total Participation
                  </h4>
                </div>
              </div>
              <div
                className="funfact-one__col col-lg-3 col-sm-6 wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="200ms"
              >
                <div className="funfact-one__item">
                  <h3 className="funfact-one__item__number count-box">
                    <span className="count-text">{tcount}</span>
                  </h3>
                  <h4 className="funfact-one__item__title">
                    Tournaments Participated
                  </h4>
                </div>
              </div>
              <div
                className="funfact-one__col col-lg-3 col-sm-6 wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="300ms"
              >
                <div
                  className="funfact-one__item"
                  onClick={() => setMLShow(true)}
                  style={{ cursor: "pointer" }}
                >
                  <h3 className="funfact-one__item__number count-box">
                    <span className="count-text">{mcount}</span>
                  </h3>
                  <h4
                    className="funfact-one__item__title"
                    style={{ textDecoration: "underline" }}
                  >
                    Medals
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Modal show={mlshow} size="xl">
          <Modal.Header>
            <h6>Achievements List</h6>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                  columnDefs={columnDefs}
                  rowData={medlist}
                  pagination="true"
                  paginationPageSize="10"
                  suppressExcelExport={true}
                  suppressDragLeaveHidesColumns={true}
                  sortingOrder={["asc", "desc"]}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <a className="btn btn-danger" onClick={() => setMLShow(false)}>
              <i className="fa fa-times"></i> Close
            </a>
          </Modal.Footer>
        </Modal>

        {stlist.length > 0 && (
          <section
            className="testimonials-two @@extraClassName"
            id="testimonials"
          >
            <div className="container">
              <div className="row gutter-y-50 align-items-center">
                <div className="col-xl-4 col-md-4">
                  <div className="testimonials-two__content">
                    <div className="sec-title @@extraClassName">
                      <div className="sec-title__top">
                        <div className="sec-title__shape">
                          <div className="sec-title__shape__one"></div>
                          <div className="sec-title__shape__two"></div>
                        </div>
                        <h6 className="sec-title__tagline">Glory Narratives</h6>
                      </div>
                      <h3 className="sec-title__title">
                        Success <br /> Stories
                      </h3>
                    </div>
                    <div className="testimonials-two__custome-navs"></div>
                  </div>
                </div>

                <div className="col-xl-8 col-md-8">
                  <Carousel
                    swipeable={true}
                    draggable={true}
                    showDots={true}
                    responsive={responsive}
                    ssr={true} // means to render carousel on server-side.
                    infinite={true}
                    autoPlay={true}
                    autoPlaySpeed={5000}
                    keyBoardControl={true}
                    customTransition="all .5"
                    transitionDuration={500}
                    containerClass="carousel-container"
                    removeArrowOnDeviceType={["tablet", "mobile"]}
                    // deviceType={this.props.deviceType}
                    dotListClass="custom-dot-list-style"
                    itemClass="carousel-item-padding-40-px"
                  >
                    {stlist.map((item, i) => {
                      return (
                        <div
                          style={{ height: "350px" }}
                          key={i}
                          className="mt-2"
                        >
                          <div className="easilon-stretch-element-inside-column pe-2">
                            <div className="testimonials-two__carousel easilon-owl__carousel owl-theme owl-carousel">
                              <div className="item">
                                <div className="testimonial-card-two @@extraClassName">
                                  <div
                                    className="testimonial-card-two__inner"
                                    onClick={() => handlestory(item.id)}
                                  >
                                    <div className="testimonial-card-two__top">
                                      <div className="testimonial-card-two__image">
                                        <img
                                          src={stpath + item.article_image}
                                          alt={item.article_title}
                                        />
                                      </div>
                                      <svg
                                        className="testimonial-card-two__icon"
                                        viewBox="0 0 56 41"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M0 25.4448H11.1378L3.71254 40.2951H14.8503L22.2756 25.4448V3.16919H0V25.4448Z" />
                                        <path d="M29.7004 3.16919V25.4448H40.8382L33.413 40.2951H44.5508L51.976 25.4448V3.16919H29.7004Z" />
                                        <path d="M14.307 21.7756H3.66919V0.5H24.9448V22.1576L17.7105 36.6259H7.69075L14.7542 22.4992L15.116 21.7756H14.307Z" />
                                        <path d="M44.0082 21.7756H33.3704V0.5H54.646V22.1576L47.4117 36.6259H37.3919L44.4554 22.4992L44.8172 21.7756H44.0082Z" />
                                      </svg>
                                    </div>
                                    <div className="testimonial-card-two__bottom">
                                      <div className="testimonial-card-two__identity">
                                        <h4 className="testimonial-card-two__name">
                                          {item.article_title}
                                        </h4>
                                        <p className="testimonial-card-two__quote">
                                          {item.article_description}
                                        </p>
                                      </div>
                                    </div>
                                    {/* <p className="testimonial-card-two__quote">
                                    <span>Atheletics </span>
                                    <br /> Gold Medal - xx international
                                  </p> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </Carousel>

                  <Modal show={sshow} size="xl">
                    <Modal.Header>
                      <h4>Success Stories Details</h4>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="owl-item active">
                        <div className="item">
                          <div className="testimonial-card-two @@extraClassName">
                            <div className="testimonial-card-two__inner">
                              <div className="row">
                                <div className="col-md-6">
                                  <img src={sphto} width="100%" />
                                </div>
                                <div className="col-md-6">
                                  <div className="testimonial-card-two__bottom">
                                    <div className="testimonial-card-two__identity">
                                      <h4 className="testimonial-card-two__name">
                                        {stitle}
                                      </h4>
                                      <p className="testimonial-card-two__quote">
                                        {sdesc}
                                      </p>
                                    </div>
                                  </div>
                                  <p className="testimonial-card-two__quote">
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: sdesc1,
                                      }}
                                    />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <div className="text-right">
                        <a
                          className="btn btn-danger"
                          onClick={handlestoryclose}
                        >
                          <i className="fa fa-times"></i> Close
                        </a>
                      </div>
                    </Modal.Footer>
                  </Modal>
                </div>
              </div>
            </div>
          </section>
        )}

        {gllist.length > 0 && (
          <section className="work-process-one section-space position-relative">
            <div
              className="why-choose-one__bg"
              style={{
                backgroundImage: `url(${require("../assets/images/shapes/why-choose-bg-1-1.png")})`,
              }}
            ></div>
            <div className="container">
              <div className="sec-title sec-title--center">
                <h3 className="sec-title__title">Gallery</h3>
                <div className="sec-title__top">
                  <div className="sec-title__shape">
                    <div className="sec-title__shape__one"></div>
                    <div className="sec-title__shape__two"></div>
                  </div>
                  <div className="sec-title__shape">
                    <div className="sec-title__shape__one"></div>
                    <div className="sec-title__shape__two"></div>
                  </div>
                </div>
              </div>
              <div className="row gutter-y-30">
                {gllist.map((data, i) => {
                  return (
                    <div
                      className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp animated"
                      data-wow-duration="1500ms"
                      data-wow-delay="00ms"
                      style={{
                        visibility: "visible",
                        animationDuration: "1500ms",
                        animationDelay: "0ms",
                        animationName: "fadeInUp",
                      }}
                      key={i}
                    >
                      <div className="work-process-one__item">
                        <div className="work-process-one__item__image">
                          <img
                            src={gtpath + data.imagename}
                            // src={require("../../../../assets/images/resources/1.jpg")}
                            alt="work process"
                            onError={(e) => errorimghandle(e)}
                          />
                          <button
                            id="openGalleryBtn"
                            className="btn btn-primary work-process-one__item__number"
                            onClick={() => handlegcpopen(data.tournament_id)}
                          >
                            Open Gallery
                          </button>
                          <svg
                            className="work-process-one__item__shape"
                            viewBox="0 0 242 67"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M239.497 33.8939L207.961 65.4318H4L35.5698 33.8939L4 2.35596H207.961L239.497 33.8939Z"></path>
                          </svg>
                          <svg
                            className="work-process-one__item__circle"
                            width="136"
                            height="32"
                            viewBox="0 0 136 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M67.9555 0.758301C105.486 0.758301 135.894 7.52133 135.894 15.8938C135.894 24.2491 105.469 31.0292 67.9555 31.0292C30.425 31.0292 7.21871e-06 24.2491 7.21871e-06 15.8938C-0.0171143 7.53845 30.425 0.758301 67.9555 0.758301Z"></path>
                          </svg>
                        </div>
                        <div className="work-process-one__item__content">
                          <h3 className="work-process-one__item__title">
                            {data.meet_name}
                          </h3>
                          <p className="work-process-one__item__text">
                            {data.location}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </section>
        )}

        {reslist.length > 0 && (
          <section className="services-three section-space" id="services">
            <div
              className="services-three__bg"
              style={{
                backgroundImage: `url(${require("../assets/images/shapes/services-bg-3-1.png")})`,
              }}
            ></div>
            <div className="container">
              <div className="services-three__top">
                <div className="row gutter-y-50 align-col-xl-4 col-md-6s-center">
                  <div className="col-xl-12 col-lg-12">
                    <div className="sec-title @@extraClassName">
                      <h3 className="sec-title__title">Resources</h3>
                      <div className="sec-title__top">
                        <div className="sec-title__shape">
                          <div className="sec-title__shape__one"></div>
                          <div className="sec-title__shape__two"></div>
                        </div>
                        <div className="sec-title__shape">
                          <div className="sec-title__shape__one"></div>
                          <div className="sec-title__shape__two"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container">
              <div className="row gutter-y-30">
                {reslist.map((item, index) => {
                  return (
                    <div
                      className="col-lg-4 col-md-6 wow fadeInUp animated"
                      data-wow-duration="1500ms"
                      data-wow-delay="100ms"
                      key={index}
                    >
                      <div
                        className="services-three__card"
                        onClick={(e) =>
                          handlepop(
                            item.file_name,
                            item.file_type,
                            item.file_or_url
                          )
                        }
                      >
                        {item.file_type === "Photo" && (
                          <a className="services-three__card__image">
                            <img
                              height="300px"
                              src={respath + item.file_name}
                              // src={require("../../../../assets/images/resources/12.jpg")}
                              alt="business loan"
                            />
                            <img
                              height="300px"
                              src={respath + item.file_name}
                              alt="business loan"
                            />
                            <span className="services-three__card__overlay"></span>
                          </a>
                        )}
                        {item.file_type === "Video" && (
                          <a className="services-three__card__image">
                            <img
                              height="300px"
                              src={require("../assets/images/video.png")}
                              alt="business loan"
                            />
                            <img
                              height="300px"
                              src={require("../assets/images/video.png")}
                              alt="business loan"
                            />
                            <span className="services-three__card__overlay"></span>
                          </a>
                        )}

                        {item.file_type === "PDF" && (
                          <a className="services-three__card__image">
                            <img
                              height="300px"
                              src={require("../assets/images/pdf.png")}
                              alt="business loan"
                            />
                            <img
                              height="300px"
                              src={require("../assets/images/pdf.png")}
                              alt="business loan"
                            />
                            <span className="services-three__card__overlay"></span>
                          </a>
                        )}

                        {/* <div className="services-three__card__content">
                                <h3 className="services-three__card__title">
                                  <a>{item.tag_name}</a>
                                </h3>
                                {item.file_type === "Video" && (
                                  <a
                                    className="services-three__card__btn"
                                    onClick={(e) =>
                                      handlepop(
                                        item.file_name,
                                        item.file_type,
                                        item.file_or_url
                                      )
                                    }
                                  >
                                    <span className="services-three__card__btn__icon">
                                      <i className="icon-arrow-right"></i>
                                    </span>
                                  </a>
                                )}

                                {item.file_type !== "Video" && (
                                  <a
                                    className="services-three__card__btn"
                                    onClick={(e) =>
                                      handlepop(
                                        respath + item.file_name,
                                        item.file_type,
                                        item.file_or_url
                                      )
                                    }
                                  >
                                    <span className="services-three__card__btn__icon">
                                      <i className="icon-arrow-right"></i>
                                    </span>
                                  </a>
                                )}
                              </div> */}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </section>
        )}

        <Modal show={ishow} size="lg" onHide={imageclose}>
          <Modal.Header>
            <h4> Resources</h4>
          </Modal.Header>
          <Modal.Body>
            <Row className="row-sm mx-0">
              <Col lg={12} md={12}>
                <div className="form-group">
                  {pimgtype === "Video" && pimgurl === "url" && (
                    <iframe
                      width="100%"
                      height="300"
                      src={pimage}
                      frameBorder="0"
                      // allow="autoplay; encrypted-media"
                      allowFullScreen
                      title="Embedded youtube"
                    />
                  )}

                  {pimgtype === "Video" && pimgurl !== "url" && (
                    <video controls width="100%" height="300">
                      <source src={pimage} type="video/mp4" />
                    </video>
                  )}

                  {pimgtype === "PDF" && (
                    <iframe
                      width="100%"
                      height="400"
                      src={pimage}
                      allowFullScreen
                    />
                  )}

                  {pimgtype === "Photo" && (
                    <img src={pimage} alt="Photo" width="100%" />
                  )}
                </div>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <a className="btn btn-danger" onClick={imageclose}>
              Close
            </a>
          </Modal.Footer>
        </Modal>

        <Modal show={gcpshow} size="xl">
          <Modal.Header>
            <h4>Gallery</h4>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              {gphoto.map((item, index) => {
                return (
                  <div
                    className="col-md-2 mt-4"
                    key={index}
                    style={{ position: "relative" }}
                  >
                    {/* <a
                      className="like-share"
                      onClick={() => handlelike(item.id)}
                    >
                      
                      {!item.like && (
                        <i
                          className="fa fa-heart fa-lg"
                          style={{ color: "#fff" }}
                        ></i>
                      )}
                      {item.like && <i className="fa fa-heart fa-lg"></i>}
                    </a> */}
                    <a
                      className="photo-share"
                      onClick={() => handleshow(item.src)}
                    >
                      <i
                        className="fas fa-share fa-lg"
                        style={{ color: "#fff" }}
                      ></i>
                    </a>

                    <img
                      className="photoimg"
                      src={item.src}
                      height="100px"
                      alt="Photo"
                    />
                  </div>
                  
                );
              })}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="text-right  mt-2">
              <a className="btn btn-danger" onClick={handlegcpclose}>
                <i className="fa fa-times"></i> Close
              </a>
            </div>
          </Modal.Footer>
        </Modal>

        <Modal show={show} size="lg">
          <Modal.Header>
            <h4>Share Photos</h4>
          </Modal.Header>
          <Modal.Body>
            <Row className="row-sm mt-3">
              <div className="text-center">
                <WhatsappShareButton
                  url={shareUrl}
                  title="Hey, check out my photos!"
                  className="me-3"
                >
                  <WhatsappIcon size={44} round={true} />
                </WhatsappShareButton>
                <FacebookShareButton
                  url={shareUrl}
                  quote="Hey, check out my photos!"
                  className="me-3"
                >
                  <FacebookIcon size={44}></FacebookIcon>
                </FacebookShareButton>
                <TwitterShareButton
                  url={shareUrl}
                  title="Hey, check out my photos!"
                  className="me-3"
                >
                  <TwitterIcon size={44}></TwitterIcon>
                </TwitterShareButton>
              </div>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <div className="text-right  mt-2">
              <a className="btn btn-danger" onClick={handleclose}>
                <i className="fa fa-times"></i> Close
              </a>
            </div>
          </Modal.Footer>
        </Modal>

        <footer className="main-footer main-footer--home">
          <div
            className="main-footer__bg"
            style={{
              backgroundImage: `url(${require("../assets/images/shapes/footer-bg-1-1.png")})`,
            }}
          ></div>
          <div className="main-footer__top">
            <div className="container">
              <div className="row gutter-y-40">
                <div
                  className="col-xl-12 col-lg-12 wow fadeInUp text-center"
                  data-wow-duration="1500ms"
                  data-wow-delay="00ms"
                >
                  <div className="footer-widget footer-widget--about text-center">
                    <a className="footer-widget__logo">
                      <img src={require("../assets/images/logo_sv.png")} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="main-footer__bottom">
            <div className="container">
              <div className="main-footer__bottom__inner">
                <div className="row gutter-y-40 align-items-center">
                  <div
                    className="col-md-6 wow fadeInUp mt-0"
                    data-wow-duration="1500ms"
                    data-wow-delay="000ms"
                  >
                    <div className="main-footer__bottom__copyright">
                      <p className="main-footer__copyright left_footer">
                        &copy; Copyright <span className="dynamic-year"></span>{" "}
                        by{" "}
                        <a
                          href="https://pathwayz.sportzvillage.com/"
                          target="_blank"
                        >
                          Sportz Village
                        </a>
                        .
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 mt-0">
                    <div className="main-footer__bottom__copyright">
                      <p className="main-footer__copyright">
                        Developed by{" "}
                        <a href="https://sportingindia.tech/" target="_blank">
                          Sportingindia
                        </a>
                        .
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>

      <a data-target="html" className="scroll-to-target scroll-to-top">
        <span className="scroll-to-top__text">back top</span>
        <span className="scroll-to-top__wrapper">
          <span className="scroll-to-top__inner"></span>
        </span>
      </a>
    </div>
  );
};
